import React from "react"

import { Box } from "@mui/material"

import { t } from "@lingui/macro"

import {
    ErrorResponse,
    Loading,
    RestResponse,
} from "@sinossi/mates-react-library"

import withUseRouter, { UseRouterParams } from "services/router"
import {
    PageHeader,
    PageSectionTitle,
    RoutesData,
} from "components/commons"
import {
    MatesComponent,
    MatesComponentState,
} from "components/mates-component"
import { MicrojobTable } from "components/microjob/microjob-table/microjob-table"
import { UserServices } from "services/user.services"
import {
    MicrojobberRequest,
    MicrojobberWrapper,
} from "models/microjobber"
import { PaginatedResponse } from "models"

interface MicrojobProps extends UseRouterParams {
}
interface MicrojobState extends MatesComponentState {
    request: MicrojobberRequest
    loading: boolean
    microjobbers: PaginatedResponse<MicrojobberWrapper> | null
}
class Microjob extends React.Component<MicrojobProps, MicrojobState> {
    private readonly matesComponent: MatesComponent<MicrojobProps, MicrojobState> = new MatesComponent(this)

    constructor(props: any) {
        super(props);
        this.state = {
            ...this.matesComponent.setupState(),
            request: MicrojobberRequest.empty(),
            loading: true,
            microjobbers: null,
        }
    }

    public componentDidMount() {
        this.filterMicrojobbers()
    }

    private filterMicrojobbers = (): void => {
        UserServices.getMicrojobbers(
            this.state.request,
            this.getMicrojobbersCallback,
            this.matesComponent.onError
        )
    }

    private getMicrojobbersCallback = (response: RestResponse<PaginatedResponse<MicrojobberWrapper>, ErrorResponse>): void => {
        if (response.hasError()) {
            this.matesComponent.onError(response)
            return
        }

        this.setState(() => ({
            loading: false,
            microjobbers: response.data,
        }))
    }

    private handleTableCallback = (data: MicrojobberRequest) => {
        this.setState(
            () => ({
                loading: true,
                request: {
                    ...this.state.request,
                    ...data,
                },
            }),
            this.filterMicrojobbers
        )
    }

    private handleSearchbarCallback = (data: MicrojobberRequest) => {
        this.setState(
            () => ({
                loading: true,
                request: {
                    ...data,
                    orderBy: this.state.request.orderBy,
                    orderType: this.state.request.orderType,
                    pageSize: 10,
                    pageId: 0,
                },
            }),
            this.filterMicrojobbers
        )
    }

    render() {
        return (
            <Box sx={{ width: '100%', pt: 2, position: "relative" }}>
                <Loading show={this.state.loading} />
                <PageHeader
                    title={RoutesData.MICROJOB.title}
                    paths={[RoutesData.DASHBOARD, RoutesData.MICROJOB]}
                />

                {/*<MicrojobAdvancedSearch handleCallback={this.handleSearchbarCallback} />*/}
                <Box sx={{ mt: 3 }}>
                    <PageSectionTitle title={t({ id: "microjob-user-title-table", message: "Microjobs" })} />
                    {
                        this.state.microjobbers &&
                        <MicrojobTable
                            data={this.state.microjobbers}
                            handleCallback={this.handleTableCallback} />
                    }
                </Box>
            </Box>
        )
    }
}

export default withUseRouter(Microjob)
